import { useSelector } from 'react-redux';
import { ConditionalDisplay } from '@rsos/base-components';
import { useFlag } from '@rsos/flags';
import checkAgent511Access from '@rsos/utils/checkAgent511Access';
import { SettingsManagementState } from '../../reducers';
import styles from '../settings.module.css';
import { Agent511AudioSettings } from './Agent511AudioSettings';
import { FollowupMessageAudioSetttings } from './FollowupMessageAudioSettings';
import { InitialTextMessageAudioSettings } from './InitialTextMessageAudioSettings';

export const TextMessagingSettings = () => {
  const hasAgent511 = useHasAgent511();
  const followUp = useFlag('follow-up-text-notification');

  return (
    <div className={styles.section}>
      <h2 className={styles.title}>911 Text Messaging</h2>
      <div className={styles.description}>
        Manage notification settings and alert sounds for all 911 text sessions.
      </div>
      <div className={styles.cardBlock}>
        <ConditionalDisplay
          dataName="agent-511-settings"
          conditions={[
            {
              showIf: hasAgent511,
              reason:
                'Agent511 Capability and Permission need to be on to show these settings',
            },
          ]}
        >
          <Agent511AudioSettings />
        </ConditionalDisplay>

        <InitialTextMessageAudioSettings />
        <ConditionalDisplay
          dataName="followup-settings"
          conditions={[
            {
              showIf: followUp,
              reason: 'Needs follow-up-text-notification flag',
            },
          ]}
        >
          <FollowupMessageAudioSetttings />
        </ConditionalDisplay>
      </div>
    </div>
  );
};

// This is still a travesty but I have to stop somewhere
function useHasAgent511() {
  const psaps = useSelector((state: SettingsManagementState) => state.psaps);
  const sinatra = useSelector(
    (state: SettingsManagementState) => state.sinatra,
  );
  return checkAgent511Access(psaps, sinatra) as boolean;
}
